export const BE_SERVER_ENDPOINT = "naapi-read.bidgely.com";
export const API_PROTOCOL = "https://";
export const GA_TRACKING_ID = "UA-35481970-12";
export const MOUSEFLOW_PROJECT_ID = "fd804b37-89a2-46d6-a77f-461667941922";